import script from "./footer-two.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-two.vue?vue&type=script&setup=true&lang=js"

import "./footer-two.vue?vue&type=style&index=0&id=1668871e&lang=css"

const __exports__ = script;

export default __exports__